import { render, staticRenderFns } from "./SettingAlarm.vue?vue&type=template&id=465657cf"
import script from "./SettingAlarm.vue?vue&type=script&lang=js"
export * from "./SettingAlarm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports